import registerAccountComponents from './account'
import registerAdminComponents from './admin'
import registerAuthComponents from './auth'
import registerHomepageComponents from './homepage'
import registerResourcesComponents from './resources'
import registerSdsSearchComponents from './sds_search'
import registerUiComponents from './ui'
import registerUserManagementComponents from './user_management'

export default {
  install (app) {
    registerAccountComponents(app)
    registerAdminComponents(app)
    registerAuthComponents(app)
    registerHomepageComponents(app)
    registerResourcesComponents(app)
    registerSdsSearchComponents(app)
    registerUiComponents(app)
    registerUserManagementComponents(app)
  }
}
